import React from "react";
import API from "../../../utils/API";
import SectionHeader from "../../../components/views/SectionHeader";
import RegistrationFlowListItem from "./registrationFlowListItem";
import CreateRegistrationFlowModal from "./modals/createRegistrationFlowModal";
import { Route, Switch } from "react-router-dom";
import RegistrationFlowSetup from "./registrationSetup";
import LoadingWizard from "../../../components/spinner/wizard";
import DeleteFlowModal from "./modals/deleteFlowModal";

class RegistrationFlows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flows: [],
            addFlowModalOpen: false,
            deleteFlowModalOpen: false,
            focusedFlow: null,
            loading: true,
        }
    }

    componentDidMount() {
        const { orgId, eventId } = this.props;

        API().get(`Organizations/${orgId}/events/${eventId}/registrationFlows`).then((res) => {
            if (res.data) {
                const flows = res.data.map((flow) => {
                    return {
                        ...flow,
                        registrationGroup: flow.registrationGroup ? this.props.event.groups.find((group) => group._id === flow.registrationGroup) : null,
                    }
                });
                this.setState({ flows, loading: false });
            }
        });
    }

    addRegistrationFlow = (flow) => {
        flow.registrationGroup = this.props.event.groups.find((group) => group._id === flow.registrationGroup);
        this.setState((prevState) => ({
            flows: [...prevState.flows, flow],
            addFlowModalOpen: false
        }));
        this.props.refreshSectionCounts();
    }

    updateRegistrationFlow = (flow) => {
        const { flows } = this.state;
        const index = flows.findIndex((f) => f._id === flow._id);
        if (index !== -1) {
            flows[index] = flow;
            this.setState({ flows });
        }
    }

    removeRegistrationFlow = (flowId) => {
        const { flows } = this.state;
        const index = flows.findIndex((f) => f._id === flowId);
        if (index !== -1) {
            flows.splice(index, 1);
            this.setState({ flows });
        }
        this.props.refreshSectionCounts();
    }

    render() {
        const { flows, addFlowModalOpen, deleteFlowModalOpen, loading } = this.state;
        const { event, orgId } = this.props;

        return (<Switch>
            <Route path="/:organization/events/:eventId/registrationFlows/:flowId">
                <RegistrationFlowSetup
                    event={event}
                    organization={this.props.org}
                    eventId={event._id}
                    orgId={orgId}
                    fields={this.props.fields}
                    account={this.props.account}
                    updateFlow={this.updateRegistrationFlow}
                    addGroup={this.props.addGroup}
                    removeFlow={this.removeRegistrationFlow}
                />
            </Route>
            <Route path="/:organization/events/:eventId/registrationFlows">
                <div className={`sectionContainer`}>
                    <SectionHeader
                        breadcrumbs={[
                            {
                                name: event.name
                            }
                        ]}
                        title="Registration Flows"
                        description="Event registration flows are used to determine how attendees register for your event. You can create multiple flows to accommodate different types of attendees."
                        mainActions={[
                            {
                                label: "Add Flow",
                                onClick: () => {
                                    this.setState({ addFlowModalOpen: true });
                                }
                            }
                        ]}
                    >
                    </SectionHeader>
                    <hr />
                    <div className="sectionContent mt-10">
                        {!loading && <div className="flex gap20">

                            {flows.length > 0 ? (
                                <div className="regFlowList">
                                    {flows.map((flow) => (
                                        <RegistrationFlowListItem
                                            flow={flow}
                                            key={flow.id}
                                            organization={this.props.org}
                                            event={event}
                                            toggleDeleteFlowModal={() => this.setState({ deleteFlowModalOpen: true, focusedFlow: flow })}
                                        />
                                    ))}
                                </div>
                            ) : (<div className="explainerBox">
                                <i className="las la-info-circle" style={{ fontSize: 50 }}></i>
                                <div>
                                    <h2>Create Your First Flow</h2>
                                    <p>No registration flows available. Please add a flow to get started.</p>
                                </div>
                            </div>
                            )}
                        </div>}
                        {loading && <LoadingWizard loading={loading} text="Loading Registration Flows" />}
                    </div>

                    {addFlowModalOpen && (<CreateRegistrationFlowModal
                        isOpen={addFlowModalOpen}
                        toggle={() => this.setState({ addFlowModalOpen: false })}
                        eventId={event._id}
                        event={event}
                        orgId={orgId}
                        groups={event.groups}
                        onSuccess={(flow) => {
                            this.setState((prevState) => ({
                                flows: [...prevState.flows, flow],
                                addFlowModalOpen: false
                            }));
                        }}
                        addGroup={this.props.addGroup}
                        updateFlows={this.addRegistrationFlow}
                        onError={(error) => {
                            console.error("Error adding flow:", error);
                        }}
                    />)}

                    {deleteFlowModalOpen && <DeleteFlowModal
                        isOpen={deleteFlowModalOpen}
                        toggle={() => this.setState({ deleteFlowModalOpen: false })}
                        flow={this.state.focusedFlow}
                        orgId={orgId}
                        eventId={event._id}
                        onDelete={(flowId) => {
                            this.removeRegistrationFlow(flowId);
                            this.setState({ deleteFlowModalOpen: false, focusedFlow: null });
                        }}
                    />}
                </div>
            </Route>
        </Switch>
        );
    }
}

export default RegistrationFlows;